import ReactDOM from "react-dom";
import React from "react";
import CurriculumBlock from "./CurriculumBlock/CurriculumBlock";

const init = () => {
  const blocks = document.querySelectorAll("[data-masonry]");
  blocks
    ? blocks.forEach(element => {
        const curriculumData = JSON.parse(
          element.getAttribute("data-curriculum")
        );
        ReactDOM.render(
          <CurriculumBlock curriculumData={curriculumData} />,
          element
        );
      })
    : null;
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/curriculumBlock.js